import { InfoState } from '@tmapy/config';

const initialState: InfoState = {
  services: [],
  data: {},
};

export const getInitialState: () => InfoState = () => initialState;
